import { Campaign, CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

import { transformCampaignApiToCommonFormFields } from './transformCampaignApiToCommonFormFields';
import { API_UNLIMITED_MAX_DELIVERY_DISTANCE } from '../../components/budget-section/constants';
import { EndOfDayFormValues, ItemDiscountFormValues } from '../../types';
import { getItemDiscountType } from '../getItemDiscountType';

export const transformCampaignApiToItemDiscountForm = (
  campaign: Campaign,
  timezone: string,
): ItemDiscountFormValues => ({
  ...transformCampaignApiToCommonFormFields(campaign, timezone),
  campaignType: CampaignType.ITEM_DISCOUNT,
  itemIds: campaign.item_discount.items?.item_ids ?? [campaign.item_discount.target_item.item_id],
  itemTriggerCount: campaign.item_discount.item_trigger_count,
  discountType: getItemDiscountType(campaign.item_discount),
  amount: campaign.item_discount.amount
    ? convertMonetaryIntToDecimal(campaign.item_discount.amount, campaign.currency)
    : undefined,
  percentage: campaign.item_discount.percentage ?? undefined,
  freeItemsCount: campaign.item_discount.free_items_count ?? undefined,
  agreementTermsAndConditions: true,
  maxDeliveryDistance: API_UNLIMITED_MAX_DELIVERY_DISTANCE, // TODO theCybulski: confirm with BE
});

export const transformCampaignApiToEndOfDayCampaignForm = (
  campaign: Campaign,
  timezone: string,
): EndOfDayFormValues => ({
  ...transformCampaignApiToItemDiscountForm(campaign, timezone),
  campaignType: CampaignType.END_OF_DAY,
});
